import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import OverviewShipment from './OverviewShipment';
import {
	Container,
	Row,
	Col,
	Button,
	Card,
	CardBody,
	Input,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	Table
} from 'reactstrap';
import profileImg from '../../assets/images/profile-img.png';
import varificationImage from '../../assets/images/verification-img.png';
//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import {
	getChartsDataLoading as onGetChartsData,
	getTotalShipmentLoading,
	getTotalCurrentMonthShipmentLoading
} from '../../store/actions';
import moment from 'moment';
import Spinners from 'components/Common/Spinner';
import { Link } from 'react-router-dom';
import StackedColumnChart from './StackedColumnChart';
import classNames from 'classnames';
import TaskSchedule from './TaskSchedule';

const Dashboard = props => {
	const [modal, setModal] = useState(false);
	const [subscribeModal, setSubscribeModal] = useState(false);
	const [selectedMonthYear, setSelectedMonthYear] = useState(new Date());
	const [showMonthPicker, setShowMonthPicker] = useState(false);

	const DashboardProperties = createSelector(
		state => state.Dashboard,
		dashboard => ({
			chartsData: dashboard.getChartsData,
			chartsDataLoading: dashboard.getChartsDataLoading,
			isYearDataLoading: dashboard.totalyearShipmentLoading,
			yearDataValue: dashboard.totalyearShipmentData,
			isMonthDataLoading: dashboard.totalCurrentMonthShipmentLoading,
			monthDataValue: dashboard.totalCurrentMonthShipmentData
		})
	);

	const { chartsData, chartsDataLoading, isYearDataLoading, yearDataValue, isMonthDataLoading, monthDataValue } =
		useSelector(DashboardProperties);

	const UserRoleProperties = createSelector(
		state => state.Login,
		role => ({
			userRole: role.userRole
		})
	);

	const { userRole } = useSelector(UserRoleProperties);

	useEffect(() => {
		setTimeout(() => {
			//setSubscribeModal(true);
		}, 2000);
	}, []);

	const [periodData, setPeriodData] = useState([]);
	const [periodType, setPeriodType] = useState('containers');

	useEffect(() => {
		if (chartsData && chartsData?.bookingData && chartsData?.bookingData.length > 0) {
			let extractCountFromOutputData = chartsData?.bookingData?.map(item => item.count);
			let graphData = [
				{
					name: periodType,
					data: [...extractCountFromOutputData]
				}
			];
			setPeriodData(graphData);
		}
	}, [chartsData]);

	const onChangeChartPeriod = pType => {
		setPeriodType(pType);
		dispatch(onGetChartsData(moment(selectedMonthYear).format('YYYY'), pType));
	};

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(
			getTotalCurrentMonthShipmentLoading({
				selectedMonth: moment(selectedMonthYear).startOf('month').format('DD-MM-YYYY')
			})
		);
		dispatch(
			getTotalShipmentLoading({ selectedMonth: moment(selectedMonthYear).startOf('month').format('DD-MM-YYYY') })
		);
		dispatch(onGetChartsData(moment(selectedMonthYear).format('YYYY'), periodType));
	}, [dispatch, selectedMonthYear]);

	//meta title
	document.title = 'Dashboard | TRAXAA';
	return (
		<React.Fragment>
			<div className="page-content">
				<Container fluid>
					{/* Render Breadcrumb */}
					<Breadcrumbs title={props.t('Dashboards')} breadcrumbItem={props.t('Dashboard')} />

					<Row>
						<Col xl="4">
							<Row>
								<Col md="12" key={'totaldata'}>
									<Card className="mini-stats-wid">
										{isYearDataLoading ? (
											<div className="d-flex">
												<div className="flex-grow-1">
													<div className="pt-5 pb-5 text-center">
														<Spinners setLoading={() => {}} />
													</div>
												</div>
											</div>
										) : (
											<div>
												<div className="bg-primary-subtle">
													<Row>
														<Col xs="7">
															<div className="text-primary p-3">
																<h5>{props.t('Bookings Overview')}</h5>
																<h6>
																	<span className=" font-size-12 text-black">
																		Bookings in {moment(selectedMonthYear).format('YYYY')}'s Total
																	</span>
																</h6>
															</div>
														</Col>
														<Col xs="5" className="align-self-end">
															<img src={profileImg} alt="" className="img-fluid" />
														</Col>
													</Row>
												</div>
												<CardBody>
													<div className="d-flex">
														<div className="flex-grow-1">
															<h4 className="card-title"></h4>

															<div className="mb-0">
																<h6 className="text-muted mb-0 mt-3">
																	<i className="fas fa-ship text-primary" style={{ marginRight: '2px' }} /> Bookings :{' '}
																	{yearDataValue?.bookingData?.totalBookings || 0}
																</h6>
																<h6 className="text-muted mb-0 mt-3">
																	<i className="fas fa-boxes text-primary" style={{ marginRight: '2px' }} /> Containers
																	: {yearDataValue?.bookingData?.totalBookingsContainers || 0}
																</h6>
															</div>
														</div>
														<div>
															<div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon mt-4">
																<span className="avatar-title rounded-circle bg-primary">
																	<i className={'bx bx-copy-alt font-size-24'}></i>
																</span>
															</div>
														</div>
													</div>
												</CardBody>
											</div>
										)}
									</Card>
								</Col>
								<Col md="12" key={'monthdata'}>
									<Card className="mini-stats-wid">
										{isMonthDataLoading ? (
											<div className="d-flex">
												<div className="flex-grow-1">
													<div className="pt-5 pb-5 text-center">
														<Spinners setLoading={() => {}} />
													</div>
												</div>
											</div>
										) : (
											<div>
												<div className="bg-primary-subtle">
													<Row>
														<Col xs="7">
															<div className="text-primary p-3">
																<h5>{props.t('Month Overview')}</h5>
																<h6>
																	<span className=" font-size-12 text-black">
																		Bookings in {moment(selectedMonthYear).format('MMMM YYYY')}
																	</span>
																</h6>
															</div>
														</Col>
														<Col xs="5" className="align-self-end">
															<img
																src={varificationImage}
																style={{ width: '110px', float: 'right', marginRight: '10px' }}
																alt=""
																className="img-fluid "
															/>
														</Col>
													</Row>
												</div>
												<CardBody>
													<div className="d-flex">
														<div className="flex-grow-1">
															<div className="mb-0">
																<h6 className="text-muted mb-0 mt-3">
																	<i className="fas fa-ship text-primary" style={{ marginRight: '2px' }} /> Bookings :{' '}
																	{monthDataValue?.bookingData?.totalBookings || 0}
																</h6>
																<h6 className="text-muted mb-0 mt-3">
																	<i className="fas fa-boxes text-primary" style={{ marginRight: '2px' }} /> Containers
																	: {monthDataValue?.bookingData?.totalBookingsContainers || 0}
																</h6>
															</div>
														</div>

														<div>
															<div className="font-size-12">
																<Link
																	onClick={() => {
																		setShowMonthPicker(!showMonthPicker);
																	}}
																	id="monthbookingfilter"
																>
																	<span className="text-muted">{moment(selectedMonthYear).format('YYYY')}</span>
																	<i className="mdi mdi-calendar-range text-primary" style={{ marginLeft: '2px' }}></i>
																	<i className="mdi mdi-chevron-down text-primary" style={{ marginLeft: '2px' }}></i>
																</Link>
															</div>
															<div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon mt-2">
																<span className="avatar-title rounded-circle bg-primary">
																	<i className={'bx bx-archive-in font-size-24'}></i>
																</span>
															</div>
														</div>
													</div>
												</CardBody>
											</div>
										)}
									</Card>
								</Col>
							</Row>
							{/* <OverviewShipment /> */}
						</Col>
						<Col xl="8">
							<Card>
								<div className="bg-primary-subtle p-3">
									<div className="d-sm-flex flex-wrap">
										<h5 className="text-primary">
											{moment(selectedMonthYear).format(' YYYY')}
											{props.t(' Overview')}
										</h5>

										<div className="ms-auto">
											<ul className="nav nav-pills">
												<li className="nav-item">
													<Link
														to="#"
														className={classNames({ active: periodType === 'containers' }, 'nav-link')}
														onClick={() => {
															onChangeChartPeriod('containers');
														}}
														id="one_month"
													>
														Containers
													</Link>
												</li>
												<li className="nav-item">
													<Link
														to="#"
														className={classNames({ active: periodType === 'bookings' }, 'nav-link')}
														onClick={() => {
															onChangeChartPeriod('bookings');
														}}
														id="one_month"
													>
														Bookings
													</Link>
												</li>
											</ul>
										</div>
									</div>
								</div>
								<CardBody>
									{/* <div className="clearfix"></div> */}
									{chartsDataLoading && periodData ? (
										<div className="d-flex">
											<div className="flex-grow-1">
												<div className="pt-5 pb-5 text-center">
													<Spinners setLoading={() => {}} />
												</div>
											</div>
										</div>
									) : (
										periodData &&
										periodData.length > 0 && (
											<StackedColumnChart
												periodData={periodData}
												dataColors='["--bs-primary", "--bs-warning", "--bs-success"]'
											/>
										)
									)}
								</CardBody>
							</Card>
						</Col>
					</Row>
					<Row>
						<Col xl="12">
							<TaskSchedule />
						</Col>
					</Row>
				</Container>
			</div>
		</React.Fragment>
	);
};

Dashboard.propTypes = {
	t: PropTypes.any,
	chartsData: PropTypes.any,
	onGetChartsData: PropTypes.func
};

export default withTranslation()(Dashboard);
